import React from 'react';
import "../GuidedExperience/GuidedExperienceWizard.css";
import { useTranslation } from 'react-i18next';
import AIRPNumberInput from '../common/AIRPNumberInput/AIRPNumberInput';

interface NumberOfParkingsWizardProps {
    totalPropertyNameFromThePreviousStep?: string
    type: string;
    propertyName: string;
    parkings: Record<string, unknown>;
    updateParking: (value: number | null, name: string) => void;
}

export default function NumberOfParkingsWizard(props: NumberOfParkingsWizardProps): JSX.Element {
    const {totalPropertyNameFromThePreviousStep, type, propertyName, parkings, updateParking} = props;
    const { t } = useTranslation("guided_wizard");

    return (<div>
        <p>{t(`${type}-wizard.${type}-description-1`)}{totalPropertyNameFromThePreviousStep && <><b><u>{parkings[totalPropertyNameFromThePreviousStep] as number}</u></b>{t(`${type}-wizard.${type}-description-2`)}</>}</p>
        <div className='max-width-small'>
            <AIRPNumberInput 
                className='border'
                negatives={false}
                decimals={false}
                maxLength={5}
                name={propertyName}
                initialValue={(parkings[propertyName] as number).toString()}
                onChange={(value: number | null) => updateParking(value, propertyName)}/>
        </div>
    </div>)
}